import React from "react";

// import services data
import { services } from "../../../../constants";

const Services = () => {
  return (
    <section id="services" className="section bg-secondary">
      <div className="container mx-auto">
        <div className="flex flex-col items-center text-center">
          <h2 className="section-title before:content-services relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-28 before:hidden before:lg:block">
            What We do for clients
          </h2>
          <p className="subtitle">
            We offer comprehensive digital solutions that include graphics
            design, mobile and web development, branding, and SEO. Our designs
            are visually stunning, intuitive, and optimized for performance and
            user experience. Our custom mobile and web applications are
            responsive, dynamic, and scalable.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-y-12 md:gap-x-8 lg:gap-x-8 md:gap-y-8 lg:gap-y-8">
          {services.map((service, index) => {
            const { icon, title, services } = service;
            return (
              <div className="bg-tertiary py-4 px-2 rounded-2xl" key={index}>
                <div className="mb-4  w-full h-12 flex items-center justify-start">
                  <img src={icon} alt="" className="w-[50px] opacity-60" />
                </div>
                <h4 className="text-2xl font-medium mb-2 ">{title}</h4>
                <div>
                  <ul className="text-paragraph space-y-2 px-2">
                    {services.map((subService, idx) => (
                      <li key={idx} className="flex items-center">
                        <span className="text-accent mr-2">✔</span>
                        {subService}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
        {/* <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-tertiary p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <h3 className="text-xl font-semibold text-accent mb-4">
                {service.title}
              </h3>
              <ul className="text-paragraph space-y-2">
                {service.services.map((subService, idx) => (
                  <li key={idx} className="flex items-center">
                    <span className="text-accent mr-2">✔</span>
                    {subService}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};

export default Services;
